<template>
  <div class="container">
    <div class="filter" :class="{ disabled: !fval.status }" v-for="(fval, fkey) in filters" :key="fkey">
      <div class="filter-row input">

        <!-- Type -->

        <div
          class="filter-control type"
          :class="{ inactive: !status }"
          @click.stop="toggle('type', fkey)">
          <span v-if="fval.label">{{ _[fval.label] }}</span>
          <span v-else class="placeholder">Select ...</span>

          <span class="icon" :class="{ icon: 'icon', up: fval.options.type }">
            <font-awesome-icon :icon="['fas', fval.options.type ? 'sort-up' : 'sort-down']"/>
          </span>

          <div class="options" v-show="fval.options.type" @mouseleave="toggle('type', fkey)">
            <ul>
              <li v-for="(oval, okey) in options" :key="okey" :class="{ selected: okey === fval.column }" @click="set(fkey, okey)">
                {{ _[oval.label] || oval.label }}
              </li>
            </ul>
          </div>

        </div>

        <!-- Condtition -->

        <div
          class="filter-row condition"
          :class="{ operator: fval.column && options[fval.column].element === 'operator' }">

          <!-- Operator -->

          <div
            class="filter-control operator"
            :class="{ inactive: !status }"
            v-if="fval.column && options[fval.column].element === 'operator'"
            @click.stop="toggle('operator', fkey)">
            <span v-if="fval.operator">{{ fval.operator }}</span>
            <span v-else class="placeholder">Select ...</span>

            <span class="icon" :class="{ icon: 'icon', up: fval.options.operator }">
              <font-awesome-icon :icon="['fas', fval.options.operator ? 'sort-up' : 'sort-down']"/>
            </span>

            <div class="options" v-show="fval.options.operator" @mouseleave="toggle('operator', fkey)">
              <ul>
                <li
                  v-for="(operator, okey) in options[fval.column].operators"
                  :key="okey"
                  :class="{ selected: operator === fval.operator }"
                  @click="fval.operator = operator">
                  {{ operator }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Text -->

          <div
            class="filter-control text"
            :class="{ inactive: !status }"
            v-if="fval.column && ['operator', 'text'].includes(options[fval.column].element)">
            <input
              type="text"
              :class="{ operator: fval.hasOwnProperty('operator') }"
              @paste.prevent="paste($event, fkey, fval)"
              v-model="fval.value"
              placeholder="...">
          </div>

          <!-- Select -->

          <div
            class="filter-control select"
            :class="{ inactive: !status }"
            v-if="fval.column && options[fval.column].element === 'select'"
            @click.stop="toggle('select', fkey)">
            <div class="selected">
              <span v-if="fval.value">{{ text(fkey, fval.column) }}</span>
              <span v-else class="placeholder">Select ...</span>

              <span class="icon" :class="{ icon: 'icon', up: fval.options.select }">
                <font-awesome-icon :icon="['fas', fval.options.select ? 'sort-up' : 'sort-down']"/>
              </span>
            </div>

            <div class="options" v-show="fval.options.select" @mouseleave="toggle('select', fkey)">
              <ul>
                <li
                  v-for="(oval, okey) in options[fval.column].options"
                  :key="okey"
                  @click.stop="select($event, oval.value, fkey)">
                  <font-awesome-icon
                    class="checkbox"
                    :class="{ selected: selected(oval.value, fkey) }"
                    :icon="['fas', selected(oval.value, fkey) ? 'check-square' : 'square']"
                    :value="oval.value" />{{ value(fval, oval) }}
                  </li>
              </ul>
            </div>
          </div>

          <!-- Radio -->

          <div
            class="filter-control radio"
            :class="{ inactive: !status }"
            v-if="fval.column && options[fval.column].element === 'radio'"
            @click.stop="toggle('radio', fkey)">
            <div class="selected">
              <span v-if="fval.value">{{ text(fkey, fval.column) }}</span>
              <span v-else class="placeholder">Select ...</span>

              <span class="icon" :class="{ icon: 'icon', up: fval.options.radio }">
                <font-awesome-icon :icon="['fas', fval.options.radio ? 'sort-up' : 'sort-down']"/>
              </span>
            </div>

            <div class="options" v-show="fval.options.radio" @mouseleave="toggle('radio', fkey)">
              <ul>
                <li
                  v-for="(oval, okey) in options[fval.column].options"
                  :key="okey"
                  @click.stop="fval.value = oval.value">
                  <font-awesome-icon
                    class="radio"
                    :class="{ selected: fval.value === oval.value }"
                    :icon="['fas', fval.value === oval.value ? 'check-circle' : 'circle']"
                    :value="oval.value" />
                  {{ value(fval, oval) }}
                </li>
              </ul>
            </div>
          </div>

        </div>

      </div>

      <!-- Status -->

      <div class="filter-action status" :class="{ inactive: !status, disabled: !fval.status }" @click="toggleStatus(fkey)">
        <font-awesome-icon v-if="fval.status" :icon="['fas', 'check-square']"/>
        <font-awesome-icon v-else :icon="['fas', 'square']"/>
      </div>

      <!-- Remove -->

      <div class="filter-action remove" :class="{ inactive: !status, disabled: filters.length < 2 }" @click="removeFilter(fkey)">
        <font-awesome-icon :icon="['fas', 'minus-circle']"/>
      </div>

      <!-- Add -->

      <!-- <div v-if="fkey === (filters.length - 1)" class="filter-action add" @click="add(fkey)"> -->

      <div class="filter-action add" :class="{ inactive: !status }" @click="addFilter(fkey)">
        <font-awesome-icon :icon="['fas', 'plus-circle']"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    status: {
      type: Boolean,
      default: true
    },
    filters: Array,
    options: Object
  },
  computed: {
    ...mapGetters(['_']),
  },
  methods: {

    addFilter(index) {
      if (!this.status) return;
      this.filters.splice(index + 1, 0, {
        // type: '',
        options: { type: false },
        value: '',
        status: true
      });
    },

    removeFilter(index) {
      if (!this.status) return;
      if (this.filters.length > 1) {
        this.filters.splice(index, 1);
      }
    },

    toggleStatus(index) {
      this.filters[index].status = this.status ? !this.filters[index].status : false;
    },

    set(fkey, okey) {
      this.filters[fkey].column = okey;
      this.filters[fkey].label = this.options[okey].label;
      this.filters[fkey].format = this.options[okey].format;

      if (this.options[okey].custom) {
        this.$set(this.filters[fkey], 'custom', this.options[okey].custom);
      } else {
        this.$delete(this.filters[fkey], 'custom');
      }

      if (this.options[okey].element === 'operator') {
        this.$set(this.filters[fkey], 'operator', '');
        this.$set(this.filters[fkey].options, 'operator', false);
      } else {
        this.$delete(this.filters[fkey], 'operator');
        this.$delete(this.filters[fkey].options, 'operator');
      }

      if (this.options[okey].element === 'select') {
        this.$set(this.filters[fkey].options, 'select', false);
      } else {
        this.$delete(this.filters[fkey].options, 'select');
      }

      if (this.options[okey].element === 'radio') {
        this.$set(this.filters[fkey].options, 'radio', false);
      } else {
        this.$delete(this.filters[fkey].options, 'radio');
      }

      if (['custom', 'operator', 'select', 'radio'].includes(this.options[okey].element)) {
        this.filters[fkey].value = '';
      }
    },
    
    toggle(option, index) {
      this.filters.forEach((fval, fkey) => {
        for (let okey in this.filters[fkey].options) {
          if (fval.status && option === okey && index === fkey) {
            this.$set(fval.options, okey, !fval.options[okey]);
          } else {
            this.$set(fval.options, okey, false);
          }
        }
      });
    },

    select(event, value, fkey) {
      let fval = this.filters[fkey].value.toString();
      let values = (fval != '') ? fval.split(',') : [];
      let index = values.indexOf(value.toString());
      if (index >= 0) {
        values.splice(index, 1);
      } else {
        values.push(value);
      }
      this.filters[fkey].value = values.sort().join(',');
    },

    selected(value, fkey) {
      let fval = this.filters[fkey].value.toString();
      let values = (fval != '') ? fval.split(',') : [];
      let index = values.indexOf(value.toString());
      return index >= 0;
    },

    text(fkey, ffield) {
      let fval = this.filters[fkey].value.toString();
      let values = (fval != '') ? fval.split(',') : [];
      let text = this.options[ffield].options.reduce((carry, oval) => {
        if (values.indexOf(oval.value.toString()) >= 0) {
          let value = oval.name;
          if (this.filters[fkey].format === 'wording') value = this._[value];
          if (this.filters[fkey].format === 'date') value = this.format(value);
          carry.push(value);
        }
        return carry;
      }, []);
      return text.join(', ');
    },

    paste(event, fkey, fval) {
      if (['id', 'abstract_id'].includes(fval.column)) {
        this.filters[fkey].value = event.clipboardData.getData('text').replace(/\s+/g, ' ').trim().split(' ').join(',');
      } else {
        this.filters[fkey].value = event.clipboardData.getData('text');
      }
    },

    value(fval, oval) {
      let value = oval.name;
      if (fval.format === 'wording') value = this._[value];
      else if (fval.format === 'date') value = this.format(value);
      return value;
    },

    format(date) {
      let day = date.split('-');
      return this._.date_format_list
        .replace('&dd', ('0' + day[2]).substr(-2))
        .replace('&d', day[2])
        .replace('&mm', ('0' + day[1]).substr(-2))
        .replace('&m', day[1])
        .replace('&y', day[0]);
    }

  },
  created() {
    document.addEventListener('click', this.toggle);
  },
  destroy() {
    document.removeEventListener('click', this.toggle);
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/filter.scss';
</style>
